import { Trans } from "react-i18next";
import ICustomTranslationProps from "./ICustomTranslationProps";

const CustomTranslation: React.FC<ICustomTranslationProps> = ({ t,  i18Key, type, customComponents,customValues }) => {
	switch (type) {
		case "phone":
			return (
				<Trans
					t={t}
					i18nKey={i18Key}
					components={{ br: <br />, tel: <a href={`tel:${window.CONFIG.REACT_APP_CONTATTI.TELEFONO}`}> </a> }}
					values={{ telNumber: window.CONFIG.REACT_APP_CONTATTI.TELEFONO }}
				></Trans>
			);

		case "mail":
			return (
				<Trans
					i18nKey={i18Key}
					t={t}
					components={{ br: <br />, eMail: <a href={`mail:${window.CONFIG.REACT_APP_CONTATTI.MAIL}`}> </a> }}
					values={{ eMail: window.CONFIG.REACT_APP_CONTATTI.MAIL }}
				></Trans>
			);
		case "contatti":
			return (
				<Trans
					i18nKey={i18Key}
					t={t}
					components={{
						br: <br />,
						tel: <a href={"tel:" + window.CONFIG.REACT_APP_CONTATTI.TELEFONO}>{}</a>,
						eMail: <a href={"mailto:" + window.CONFIG.REACT_APP_CONTATTI.MAIL}>{}</a>,
					}}
					values={{ eMail: window.CONFIG.REACT_APP_CONTATTI.MAIL, telNumber: window.CONFIG.REACT_APP_CONTATTI.TELEFONO }}
				></Trans>
			);
		case "condizioniVendita":
			return (
				<Trans
					i18nKey={i18Key}
					t={t}
					components={{
						br: <br />,
						a: (
							<a href={window.CONFIG.REACT_APP_CONDIZIONI_VENDITA_LINK} target="_blank" rel="noreferrer">
								{}
							</a>
						),
					}}
					values={{ eMail: window.CONFIG.REACT_APP_CONTATTI.MAIL }}
				></Trans>
			);
		case "custom":		
			return <Trans t={t}  i18nKey={i18Key} values={customValues} components={customComponents}></Trans>;
		
		default:
			return <Trans t={t}  i18nKey={i18Key}  components={customComponents}></Trans>;
	}
};

export default CustomTranslation;
